import React from 'react';
import styles from './index.module.scss';

const FooterSocialIconsBlock = ({
  contentData,
  contentText,
  contentName,
  imgName,
  imgsNames,
  videoName,
  path_to_folder,
  links,
  hideMetaDisclaimer = false,
}) => {
  const processedImgsNames = React.useMemo(() => {
    if (!imgsNames || imgsNames === '' || imgsNames === '[]') return [];

    let imagesArray = [];

    if (typeof imgsNames === 'string') {
      try {
        imagesArray = JSON.parse(imgsNames);
      } catch (e) {
        imagesArray = imgsNames
          .split(',')
          .map((img) => img.trim())
          .filter((img) => img && img !== 'none');
      }
    } else if (Array.isArray(imgsNames)) {
      imagesArray = imgsNames.filter((img) => img && img !== 'none');
    }

    return imagesArray.map((imgName) => {
      if (imgName && imgName.includes('\\')) {
        return imgName.substring(imgName.lastIndexOf('\\') + 1);
      }
      return imgName;
    });
  }, [imgsNames]);

  const signaturesAsLinks = React.useMemo(() => {
    const raw = contentData?.imgs_signatures;
    if (!raw || raw === 'none' || raw === '[]') return [];
    let arr = [];
    try {
      arr = typeof raw === 'string' ? JSON.parse(raw) : raw;
    } catch {
      return [];
    }
    if (!Array.isArray(arr)) return [];
    return arr.map((s) => {
      const v = s != null ? String(s).trim() : '';
      return v !== '' && v.toLowerCase() !== 'none' ? v : null;
    });
  }, [contentData?.imgs_signatures]);

  return (
    <div className={styles.footerSocialIconsBlock}>
      {processedImgsNames && processedImgsNames.length > 0 && (
        <div className={styles.socialIconsContainer}>
          <div className={styles.socialIconsGrid}>
            {processedImgsNames.map((processedImgName, index) => {
              const rawLink = signaturesAsLinks[index] ?? links?.[index];
              const hasAsterisk = rawLink != null && String(rawLink).includes('*');
              const linkWithoutAsterisk = rawLink != null ? String(rawLink).replace(/\*/g, '').trim() : null;
              const href =
                linkWithoutAsterisk && linkWithoutAsterisk !== ''
                  ? linkWithoutAsterisk.startsWith('http')
                    ? linkWithoutAsterisk
                    : `https://${linkWithoutAsterisk}`
                  : null;
              const iconElement = (
                <img
                  src={path_to_folder + processedImgName}
                  alt={`Social icon ${index + 1}`}
                  className={styles.socialIcon}
                />
              );

              return (
                <div key={index} className={styles.socialIconWrapper}>
                  {hasAsterisk && <span className={styles.asterisk}>*</span>}
                  <div className={styles.socialIconItem}>
                    {href ? (
                      <a
                        href={href}
                        target='_blank'
                        rel='noopener noreferrer'
                        className={styles.socialLink}>
                        {iconElement}
                      </a>
                    ) : (
                      iconElement
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          {!hideMetaDisclaimer && processedImgsNames.length > 1 && (
            <p className={styles.disclaimer}>
              {contentText &&
                contentText.trim() !== '' &&
                contentText.trim().toLowerCase() !== 'none' && (
                  <>
                    {contentText.split('\n').map((line, i) => (
                      <React.Fragment key={i}>
                        {line}
                        {i < contentText.split('\n').length - 1 && <br />}
                      </React.Fragment>
                    ))}
                  </>
                )}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default FooterSocialIconsBlock;
